import { createApp } from 'vue'
import PageSimulation from './PageSimulation.vue'
import store from './store'

createApp(PageSimulation).use(store).mount('#app')
